import { useEffect } from 'react';
import { getInspectionStoreState } from '../store';

/**
 * Synchronizes inspection ID from URL parameter to the store.
 * Resets store when navigating away, updates ID when navigating to different inspection.
 */
export function useSynchronizeInspectionIdFromUrl(
  inspectionIdParam: string | undefined
): void {
  useEffect(() => {
    const state = getInspectionStoreState();

    if (!inspectionIdParam) {
      if (state.inspectionId || state.inspectionModel || state.inspection) {
        state.reset();
      }
      state.setInspectionLoading(false);
      return;
    }

    if (inspectionIdParam === state.inspectionId) {
      return;
    }

    const inspectionModelId = state.inspectionModel?._id;
    const inspectionViewId = state.inspection?._id;

    if (
      inspectionModelId === inspectionIdParam ||
      inspectionViewId === inspectionIdParam
    ) {
      state.setInspectionId(inspectionIdParam);
      return;
    }

    state.beginInspectionNavigation(inspectionIdParam);
  }, [inspectionIdParam]);
}
